import React, { useEffect, useState } from 'react';
import { cellRendererCheck, currencyFormat, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';

const PendingTable = ({
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
}) => {
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };
    const columns = [
        {
            dataField: 'options',
            text: 'Options',
            sort: false,
            width: 90,
            show: true,
            hidecolFilter: true,
            action: true
        },
        {
            dataField: 'poDate',
            text: 'PO Date',
            sort: false,
            width: 90,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (rowData) => dateFormate(rowData.poDate),
        },
        {
            dataField: 'wholesalerAccount',
            text: 'Acct #',
            sort: false,
            width: 115,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.wholesalerAccount),
        },
        {
            dataField: 'wholesalerName',
            text: 'Wholesaler',
            sort: false,
            width: 180,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.wholesalerName),
        },
        {
            dataField: 'poid',
            text: 'PO #',
            sort: true,
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.poid),
        },
        {
            dataField: 'packageOrdered',
            text: 'Ordered Qty',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.packageOrdered),
        },
        {
            dataField: 'orderedPackagePrice',
            text: 'Pkg Price',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData) => currencyFormat(rowData.orderedPackagePrice),
        },
        {
            dataField: 'orderedTotalPrice',
            text: 'Total Price',
            sort: false,
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            cellRenderer: (rowData) => currencyFormat(rowData.orderedTotalPrice),
        },   
    ];
    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        for(var x in colFilter){
            if(colFilter[x].filterName == "orderedPackagePrice"){
                colFilter[x].filterValue = (colFilter[x].filterValue).replace(/,/g, "")
            }
        }
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;


    return <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data?.length > 0 ? 'fixed-height' : 'default'}>
        <ReactStrapTable
            id='configuration-table1'
            fixedColumn
            data={backUpData}
            loading={loading}
            columns={columns}
            onPageSizeChange={onPageSizeChange}
            pageSize={colFilter.pageSize}
            onExport={onExport}
            hasPagination = {backUpData?.length>0 ?true : false}
            onPageChange={onHandlePageChange}
            currentPage={colFilter.currentPage}
            totalRecords={totalSize}
            handleSort={handleSort}
            onFilterCancel={handleFilterCancel}
            filters={colFilter}
            onSearchColumnFilters={handleSearchColumnFilters}
        />
    </div>;
};

export default PendingTable;
